<template>
	<v-form-group :label="label" :id="elementId" :cols="cols" :wrapped="wrapped" :error-message="errorMessage">
		<textarea
			class="form-control"
			:id="elementId"
			:value="mask.format ? masked : value"
			:rows="rows"
			:cols="cols"
			:maxlength="maxLength"
			:placeholder="placeholder"
			:style="styles"
			:disabled="disabled"
			@input="updateModel"
			@keypress="preventKeys"
			ref="textarea"
		></textarea>
	</v-form-group>
</template>

<script>
	import Base from './base';
	import VFormGroup from './form-group';
	import Masker from './masker';

	export default {
		extends: Base,

		props: {
			rows: { default: null },
			cols: { default: null },
			maxlength: { default: null },
			placeholder: { default: null },
			styles: { default: null },
			disabled: { default: false }
		},

		components: { VFormGroup },

		computed: {
			maxLength() {
				return this.mask.format ? this.mask.format.length : this.maxlength;
			},

			masked() {
				let maskedValue = Masker.maskit(this.mask, this.value);

				if (this.mask.change) {
					this.$emit('input', maskedValue);
				}

				return maskedValue;
			}
		},

		methods: {
			preventKeys($event) {
				if (this.mask.format && $event.keyCode !== 13) {
					Masker.preventKeys($event, this.mask, this.value);
				}
			},

			updateModel($event) {
				let value = $event.target.value;

				if (this.mask.format && !this.mask.change) {
					value = Masker.unmaskit(this.mask, value);
				}

				this.$emit('input', value);
			}
		}
	};
</script>


// WEBPACK FOOTER //
// textarea.vue?3779d66a